// Base values for meta tags
// So they can be added as suffixes on different pages
// Via <svelte:head>

export const siteBaseUrl = 'https://siposdani87.com';
export const blogBaseUrl = 'https://blog.siposdani87.com';

export const appName = 'BLOG.siposdani87.com';
export const appKeywords = ['Sipos Dániel', 'Senior Software Engineer', 'Developer Blog'];
export const appDescription =
	'Practical solutions to real-world software engineering challenges — Docker, TypeScript, React Native, and more. By Dániel Sipos, Senior Software Engineer.';
export const appAuthor = 'Dániel Sipos';
